module.exports = __webpack_public_path__ + "assets/ceffc06d678390a175e09381f77b4350.png";